/**
 * await until the result of the {callback} is true, poll the callback every {delay} milliseconds
 */
module.exports = async (callback, delay) => {
    return await new Promise(resolve => {
        const interval = setInterval(() => {
            if (callback()) {
                resolve();
                clearInterval(interval);
            };
        }, delay);
    });
}